/* spx-alternativa-agotado — una ficha AGOTADA ofrece su reemplazo con stock (28/09/2026, auditoría «todo todo» S4).
 *
 * La Loza Bruselas (50 reseñas, ~300 vistas en 28 días) estaba agotada y la ficha no ofrecía nada: el cliente se iba.
 * Bajo el botón de compra, mientras la variante elegida esté agotada, aparece «Agotado por ahora. Te puede gustar:» con
 * las alternativas que TENGAN stock (foto, nombre, precio y enlace). Si ninguna tiene stock, no aparece nada.
 *
 * El mapa ficha → alternativas lo pone el layout en `window.SPX_ALTERNATIVAS` ({ "handle": ["alt1", ["alt2", "Nombre corto"]] }),
 * para sumar fichas sin tocar este archivo. El nombre corto es opcional: en celular el título completo se corta y no se
 * distingue cuál es cuál. `window.SPX_ALTERNATIVAS_CFG = { color }`.
 * Fuente única: areas/paginas-propias/_comun/tema/spx-alternativa-agotado.js · publicador: alternativa-agotado.py
 */
(function () {
  var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  var mapa = window.SPX_ALTERNATIVAS || {};
  if (!h || !mapa[h] || window.__spxAlternativa) return;
  window.__spxAlternativa = 1;
  var cfg = window.SPX_ALTERNATIVAS_CFG || {};
  var color = cfg.color || '#2f2f2f';
  var s = document.createElement('style');
  s.textContent =
    '#spx-alt{margin:16px 0 8px;padding:14px;border:1px solid #e3ddd3;border-radius:10px;background:#faf8f4;font-size:14px;line-height:1.35}' +
    '#spx-alt[hidden]{display:none!important}' +
    '#spx-alt .spx-alt__t{margin:0 0 10px;font-weight:600;color:' + color + '}' +
    '#spx-alt .spx-alt__l{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:10px}' +
    '#spx-alt a{display:flex;gap:10px;align-items:center;padding:8px;border-radius:8px;background:#fff;border:1px solid #eee;color:inherit;text-decoration:none}' +
    '#spx-alt a:hover{border-color:' + color + '}' +
    '#spx-alt img{width:56px;height:56px;object-fit:cover;border-radius:6px;flex:none}' +
    '#spx-alt .spx-alt__n{display:block;font-size:13px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
    '#spx-alt .spx-alt__p{display:block;margin-top:2px;font-weight:600}';
  document.head.appendChild(s);

  var P = null, caja = null;
  var clp = function (c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); };
  var img = function (u) { return u ? (u.indexOf('//') === 0 ? 'https:' + u : u) + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160' : ''; };
  function formulario() {
    return [].filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (x) {
      return !x.closest('#mini-cart, .ajax-cart__drawer-wrapper, .modal, [role=dialog], dialog, product-card, .quick-add, #spx-alt') && x.offsetParent !== null;
    })[0];
  }
  function actual() {
    var f = formulario();
    var id = (f && f.querySelector('[name=id]') && f.querySelector('[name=id]').value) || new URLSearchParams(location.search).get('variant');
    return P.variants.filter(function (v) { return String(v.id) === String(id); })[0] ||
      P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
  }
  function marcar() { if (P && caja) caja.hidden = actual().available; }
  function pintar(alts) {
    if (!alts.length) return;
    var f = formulario();
    if (!f) return;
    caja = document.createElement('div');
    caja.id = 'spx-alt';
    caja.innerHTML = '<p class="spx-alt__t">Agotado por ahora. Te puede gustar:</p><div class="spx-alt__l">' +
      alts.map(function (a) {
        return '<a href="/products/' + a.handle + '"><img src="' + img(a.featured_image) + '" alt="" loading="lazy" width="56" height="56">' +
          '<span><span class="spx-alt__n">' + (a.__nombre || a.title).replace(/</g, '&lt;') + '</span><span class="spx-alt__p">' + clp(a.price) + '</span></span></a>';
      }).join('') + '</div>';
    f.parentNode.insertBefore(caja, f.nextSibling);
    marcar();
    var tick = function () { setTimeout(marcar, 400); };
    document.addEventListener('change', tick); document.addEventListener('click', tick);
  }
  var js = function (x) { return fetch('/products/' + x + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); };
  js(h).then(function (p) {
    if (!p || !p.variants) return;
    P = p;
    if (actual().available) return; // con stock no se busca nada: la caja solo existe para la ficha agotada
    Promise.all(mapa[h].map(function (x) {
      var par = [].concat(x);
      return js(par[0]).then(function (a) { if (a && par[1]) a.__nombre = par[1]; return a; });
    })).then(function (r) { pintar(r.filter(function (a) { return a && a.available; })); });
  });
})();
